<!-- eslint-disable keyword-spacing -->
<template lang="pug">
section.territorio
    BaseHeader#cadastrar-territorio(
        :titulo='$t("mensagens.territorio.labels.territorio")',
        icon='el-icon-plus',
        :btnTexto='$t("mensagens.territorio.cadastrarTerritorio")',
        :exibeBotao='true',
        @btnHeaderClicado='cadastrarTerritorio'
    )

    .view-container-base-header
        ModalTerritorioAdicionadoAR(
            :show='showModalTerritorioAdicionado',
            @close='closeModalTerritotorioAdicionado'
        )
        ModalNotificacaoAR(
            :show='showModalNotificacao',
            :idTerritorio='idTerritorioSelecionadoDeletar',
            @close='openAndcloseModalNotificacao'
        )

        .fields-layer
            FiltrosSucursales(
                :search.sync='search',
                :sucursal.sync='sucursal',
                :sucursais='sucursais',
                :search-placeholder='$t("mensagens.territorio.procurePeloTerritorioArgentina")',
                @buscar='onChangeSearchInput',
                @limpar='clearFiltros'
            )
        .territorio__tabela
            el-table.table-territorios(
                :key="listagemTableKey('territorios', territorios, paginacao.paginaAtual)",
                :data='territorios',
                style='width: 100%'
            )
                el-table-column(type='expand')
                    .content-expand(slot-scope='scope')
                        strong {{ $t('mensagens.territorio.territorioArgentina.pessoa') }}: <span>{{ verificarValorLabel(scope.row.nomeRepresentante) }}</span>
                        strong {{ $t('mensagens.territorio.territorioArgentina.papelPessoa') }}: <span>{{ verificarValorLabel(scope.row.papelNome) }}</span>
                        strong {{ $t('mensagens.territorio.labels.cuit') }}: <span>{{ formatarCuit(scope.row.documentoRepresentante) }}</span>

                el-table-column(
                    prop='nome',
                    :label='$t("mensagens.territorio.labels.territorio")',
                    min-width='180'
                )
                    template(slot-scope='scope')
                        span {{ verificarValorLabel(scope.row.nome) }}

                el-table-column(
                    prop='nomeSucursal',
                    label='Sucursal',
                    min-width='160'
                )
                    template(slot-scope='scope')
                        span {{ verificarValorLabel(scope.row.nomeSucursal) }}

                el-table-column(
                    prop='areaHa',
                    :label='$t("mensagens.territorio.labels.areaHa")',
                    min-width='110'
                )
                    template(slot-scope='scope')
                        span {{ verificarValorLabel(scope.row.areaHa?.toFixed(3)) }}

                el-table-column(
                    prop='dataCadastroFormatada',
                    :label='$t("mensagens.territorio.territorioArgentina.dataRegistro")',
                    min-width='130'
                )
                    template(slot-scope='scope')
                        span {{ verificarValorLabel(scope.row.dataCadastroFormatada) }}

                el-table-column(
                    prop='provinciaNome',
                    :label='$t("mensagens.territorio.labels.provincia")',
                    min-width='140'
                )
                    template(slot-scope='scope')
                        span {{ verificarValorLabel(scope.row.provinciaNome) }}

                el-table-column(
                    prop='departamentoNome',
                    :label='$t("mensagens.territorio.labels.departamento")',
                    min-width='150'
                )
                    template(slot-scope='scope')
                        span {{ verificarValorLabel(scope.row.departamentoNome) }}

                el-table-column(
                    prop='renspa',
                    :label='$t("mensagens.territorio.labels.renspa")',
                    min-width='140'
                )
                    template(slot-scope='scope')
                        span {{ formatarRenspa(scope.row.renspa) }}

                el-table-column(
                    :label='$t("mensagens.comuns.acoes")',
                    align='center',
                    min-width='80'
                )
                    template(slot-scope='scope')
                        el-dropdown.action-button(
                            @click.native='setAtivo(scope.row)',
                            trigger='click'
                        )
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='goToTerritorioDashboard(scope.row)'
                                ) {{ $t('mensagens.operacao.acoes.visualizar') }}

                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='handleClickUpdate(scope.row)'
                                ) {{ $t('mensagens.operacao.acoes.editar') }}

                                el-dropdown-item(
                                    icon='el-icon-delete',
                                    @click.native='handleClickDelete(scope.row)'
                                ) {{ $t('mensagens.operacao.acoes.remover') }}

                                el-dropdown-item(
                                    v-if='!usuarioLogado.operacaoCadastrante',
                                    icon='el-icon-download',
                                    @click.native='baixarKMLTerritorio(scope.row)'
                                ) {{ $t('mensagens.territorio.baixarPoligono') }}

                template(slot='empty')
                    el-empty(
                        :description='$t("mensagens.territorio.voceNaoPossuiTerritoriosCadastrados")'
                    )

            .tabela-rodape.paginacao-direita
                .tabela-rodape--esquerda
                    p {{ $t('mensagens.territorio.territorio') }}: {{ totalTerritorios }}

                .tabela-rodape--pagination
                    el-pagination(
                        background,
                        :page-size='paginacao.tamanhoPagina',
                        :current-page.sync='paginacao.paginaAtual',
                        layout='prev, pager, next',
                        :total='totalTerritorios',
                        @current-change='fetchTerritorios'
                    )

    #modal-delete-territorio-are-you-sure.row(v-if='deleteTerritorioModal')
        el-dialog(:visible.sync='deleteTerritorioModal', width='500px')
            span(slot='title')
                h1.mb-2.font-weight-bold(style='text-align: left') {{ $t('mensagens.territorio.removerTerritorio') }}
            .column.d-flex.justify-content-center.align-items-center.flex-column
                p.mb-5.texto-modal(v-if='statusMonitoramento === "ATIVO"')
                    | {{ $t('mensagens.territorio.naoFoiPossivelRemoverTerritorioEmMonitoramento') }}

                p.mb16.texto-modal(
                    v-else-if='statusMonitoramento === "CANCELADO"'
                )
                    b.mb-2 Atenção!
                    br
                    | {{ $t('mensagens.territorio.territorioPossuiMonitoramentosCancelados') }}

                p.mb16.texto-modal(v-else)
                    | {{ $t('mensagens.territorio.desejaRemoverTerritorio') }}

                .buttons.mb16(v-show='statusMonitoramento !== "ATIVO"')
                    el-button(
                        size='mini',
                        @click='handleCloseModalDeleteTerritorio'
                    )
                        | {{ $t('mensagens.comuns.cancelar') }}
                    el-button(
                        type='primary',
                        size='mini',
                        @click='deleteTerritorio'
                    )
                        | {{ $t('mensagens.comuns.remover') }}

    SendOrEditMonitoramento(
        v-if='showMonitoramentoModal',
        :showMonitoramentoModal='showMonitoramentoModal',
        :selectedTerritorioNome='selectedTerritorio.nome',
        :selectedTerritorio='territorioParaMonitoramento',
        actionType='send'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import FiltrosSucursales from '@/components/sucursales/FiltrosSucursales.vue';
import EmptyResult from '@/components/EmptyResult';
import SendOrEditMonitoramento from '@/components/areamonitorada/SendOrEditMonitoramento';
import ModalTerritorioAdicionadoAR from '@/components/territorio/ModalTerritorioAdicionadoAR';
import ModalNotificacaoAR from '@/components/territorio/ModalNotificacaoAR';
import { required } from 'vuelidate/lib/validators';
import territorioService from '@/services/TerritorioService';
import MonitoramentoService from '@/services/MonitoramentoService';
import debounce from 'lodash/debounce';
import { mapActions, mapGetters, mapState } from 'vuex';
import UtilsService from '@/services/UtilsService';
import { isEmpty } from 'lodash';
import formatters from '@/utils/formatters';
import SucursaleService from '@/services/SucursaleService';

export default {
    name: 'index',
    components: {
        BaseHeader,
        FiltrosSucursales,
        EmptyResult,
        SendOrEditMonitoramento,
        ModalTerritorioAdicionadoAR,
        ModalNotificacaoAR
    },
    watch: {
        search: debounce(async function () {
            await this.fetchTerritorios();
        }, 1000)
    },
    data() {
        return {
            isDropdownNotificationsOpen: false,
            visible: false,
            territorios: [],
            totalTerritorios: 0,
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 10
            },
            territoriosPendentesAprovacao: [],
            showModalTerritorioAdicionado: false,
            idTerritorioSelecionadoDeletar: null,
            showModalNotificacao: false,
            search: null,
            sucursal: '',
            sucursais: [],
            deleteTerritorioModal: false,
            selectedTerritorio: {},
            territorioParaMonitoramento: {
                idTerritorio: null,
                cultura: null,
                dataPlantio: null,
                areaDoPlantio: null,
                idSafra: null,
                produtividade: null
            },
            statusMonitoramento: '',
            order: null,
            nomeColumn: null,
            verificaMonitoramento: false
        };
    },
    validations: {
        territorio: {
            nomeTerritorio: {
                required
            }
        },
        territorioParaMonitoramento: {
            idSafra: { required }
        }
    },

    created() {
        this.fetchTerritorios();
        this.listarSucursais();
        this.resetTerritorio();
        this.clearTerritoryTableData();
    },
    filters: {
        formatarAreaDuasCasas: function (value) {
            if (!value) return '';
            const valueString = value.toString();
            return (
                Math.round(Number(valueString.replace(',', '.')) * 100) / 100
            ).toFixed(2);
        }
    },

    computed: {
        ...mapGetters(['showMonitoramentoModal', 'usuarioLogado']),
        ...mapState(['usuarioLogado'])
    },

    methods: {
        ...mapActions(['clearTerritoryTableData']),
        getRepresentante(representantes) {
            if (representantes.length === 0) {
                return '-';
            }
            return representantes[0].cpfCnpj;
        },

        toggleDropdown() {
            this.isDropdownNotificationsOpen =
                !this.isDropdownNotificationsOpen;
        },

        goToTerritorioAr(idTerritorio) {
            this.$router.push({
                name: 'VizualizarTerritorioValidacaoAR',
                params: { idTerritorio }
            });
        },

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },

        async exportarRelatorio(simplificado) {
            const url = 'territorios/exportar/' + simplificado;
            UtilsService.baixarArquivo(url);
        },

        resetTerritorio() {
            this.$v.$reset();
            this.territorio = {};
        },

        async setAtivo(value) {
            if (this.usuarioLogado.monitoramentoAccess) {
                const response = await MonitoramentoService.verificarTerritorio(
                    value.id
                );
                const data = await response.data;
                if (!isEmpty(data)) {
                    this.verificaMonitoramento = this.$t(
                        'mensagens.territorio.atualizarMonitoramento'
                    );
                } else {
                    this.verificaMonitoramento = this.$t(
                        'mensagens.territorio.enviarParaMonitoramento'
                    );
                }
            }
        },
        async fetchTerritorios() {
            let filtro = this.getFiltros();
            const { data } = await territorioService.territoriosSucursais(
                filtro
            );
            this.totalTerritorios = data.totalResultados;
            this.territorios = data.resultados;
        },

        cadastrarTerritorio() {
            this.$router.push({ name: 'TerritorioSucursalesAcoes' });
        },

        goToTerritorioDashboard(territorio) {
            this.$router.push({
                name: 'VisualizarTerritorio',
                params: { idTerritorio: territorio.id },
                query: { sucursal: true }
            });
        },

        closeModalTerritotorioAdicionado() {
            this.showModalTerritorioAdicionado = false;
        },

        openAndcloseModalNotificacao(idTerritorio) {
            this.idTerritorioSelecionadoDeletar = idTerritorio;
            this.showModalNotificacao = !this.showModalNotificacao;
        },

        handleClickUpdate(value) {
            this.$router.push({
                name: 'TerritorioSucursalesAcoes',
                query: { id: value.id, sucursal: value.idSucursal }
            });
        },

        deleteTerritorio() {
            territorioService
                .deleteSucursal(this.selectedTerritorio.id)
                .then(response => {
                    if (response.status === 200) {
                        this.deleteTerritorioModal = false;

                        this.fetchTerritorios();

                        this.$notify.success({
                            message: this.$t(
                                'mensagens.territorio.removidoComSucesso'
                            )
                        });
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.erroAoRemoverTerritorioDevidoCalculoDeProdutividade'
                            )
                        });
                    }
                });
        },

        async handleClickDelete(territorio) {
            try {
                this.selectedTerritorio.id = territorio.id;
                this.deleteTerritorioModal = true;
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroAoVerificarStatusMonitoramentos'
                    )
                });
            }
        },

        handleCloseModalDeleteTerritorio() {
            this.deleteTerritorioModal = false;
        },

        baixarKMLTerritorio(territorio) {
            territorioService.findById(territorio.id).then(({ data }) => {
                UtilsService.baixarKMLdeGeometria(data.geometria);
            });
        },

        formatarCuit(cuit) {
            return formatters.formatarCuit(cuit);
        },

        formatarRenspa(renspa) {
            if (!renspa) return '-';
            if (renspa.length !== 13) return renspa;
            return `${renspa.slice(0, 2)}.${renspa.slice(2, 5)}.${renspa.slice(
                5,
                6
            )}.${renspa.slice(6, 11)}/${renspa.slice(11)}`;
        },

        verificarValorLabel(valor) {
            if (valor) {
                return valor;
            }

            return '-';
        },

        getFiltros() {
            const filtro = {};
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.page = this.paginacao.paginaAtual - 1;
            filtro.search = String(this.search || '').replace(
                /[^a-zA-Z0-9 ]/g,
                ''
            );
            filtro.sucursal = this.sucursal || '';

            filtro.order = '&sort=data_cadastro,desc';

            return filtro;
        },

        onChangeSearchInput() {
            this.paginacao.paginaAtual = 1;
            this.fetchTerritorios();
        },

        orderName(a, b) {
            const nameA = a.label.toUpperCase();
            const nameB = b.label.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        },

        async listarSucursais() {
            try {
                const { data } = await SucursaleService.listagem();
                const dataFormat = data.sucursais
                    .map(item => {
                        return { label: item.nome, id: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));
                this.sucursais = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.sistema.erroInformacoes')
                });
            }
        },

        clearFiltros() {
            this.sucursal = '';
            this.search = '';
            this.paginacao.paginaAtual = 1;

            this.fetchTerritorios();
        }
    }
};
</script>

<style lang="scss" scoped>
.territorio {
    padding-top: 0 !important;
    height: 100%;
    width: 100%;
    overflow-y: auto;

    button {
        width: fit-content;
        cursor: pointer;
    }

    .fazendas-notificacao {
        width: 100%;
        display: flex;
        flex-direction: column;
        border: 1px solid #ddac44;
        border-radius: 5px;
        background: white;
        margin-bottom: 20px;
        .header-dropdown {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #ddac44;
            gap: 15px;
            .icon {
                padding: 10px 20px;
                background: #ddac44;
                i {
                    color: white;
                }
            }
            strong {
                font-size: 22px;
                font-weight: 500;
                font-family: 'Roboto';
                color: #3b3b3b;
            }
            .text {
                font-size: 14px;
                font-weight: 500;
                color: #3b3b3b;
            }
            .dropdown {
                font-size: 20px;
                margin-left: auto;
                margin-right: 20px;
                cursor: pointer;
            }
        }
        .body-dropdown {
            display: flex;
            flex-direction: column;
            gap: 10px;
            justify-content: center;
            align-items: center;
            padding: 15px 40px;
            .el-table {
                padding-bottom: 10px;
                border-bottom: 1px solid #eeeeee;
                .el-table__header {
                    th {
                        text-align: start !important;
                        border-bottom: none !important;
                        div {
                            font-size: 12px;
                            font-weight: 500;
                            font-family: Roboto;
                            color: #3b3b3b;
                        }
                    }
                }
                .el-table__body-wrapper {
                    tr:hover > td.el-table__cell {
                        background: unset !important;
                    }
                    td {
                        text-align: start !important;
                        border: none !important;
                        padding: 0 !important;
                        div {
                            font-size: 14px;
                            font-weight: 500;
                            font-family: Roboto;
                            color: #3b3b3b;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            gap: 5px;
                            button {
                                border: 0;
                                padding: 0;
                                background-color: unset;
                                i {
                                    font-size: 16px;
                                }
                            }
                            .view {
                                color: #1c1b1f;
                            }
                            .success {
                                color: #266728;
                            }
                            .reject {
                                color: #dc362e;
                            }
                        }
                    }
                }
            }
            .ver {
                background: none;
                border: 0;
                color: #4294ec;
                display: flex;
                align-items: center;
                gap: 5px;
                &:hover {
                    outline: none !important;
                }
                span {
                    font-size: 14px;
                    font-family: 'Roboto';
                    font-weight: 500;
                }
            }
        }
    }

    .content-expand {
        display: flex;
        align-items: center;
        gap: 25px;
        padding: 12px 48px;
        strong {
            font-size: 14px;
            font-weight: 400;
            font-family: Roboto;
            color: #3b3b3b;
            span {
                font-weight: 500;
            }
        }
    }

    .btn-exportar-relatorio {
        width: 200px;
        height: 46px;
    }

    .required-text {
        color: var(--danger);
    }

    #end-add-territorio-button {
        p {
            cursor: pointer;
        }
    }

    .el-table {
        border-radius: 5px 5px 0 0 !important;

        .cell {
            word-break: break-word !important;
        }

        .action-button {
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
    }

    .table-territorios {
        width: 100%;
        background-color: var(--white);
        border-radius: $default-border-radius;
        border-color: var(--default-border-color);
    }

    .territorio__tabela {
        .el-table {
            border-radius: 5px 5px 0 0;
            min-height: 240px;
        }

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            border-radius: 0 0 5px 5px;
            margin-top: auto;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }
    }

    .el-dialog__body {
        padding: 5px 20px;
        color: var(--text-disabled);
        font-size: 14px;
        word-break: break-all;
    }

    .buttons {
        width: 100%;
        gap: 16px;
        display: flex;
        justify-content: space-between;
    }

    .vw-100 {
        width: 100%;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }
}
</style>

<style lang="scss">
.el-table td.el-table__cell {
    border: none !important;
}
</style>
